(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getData() {
    return window.TCB_PARTS_FINDER_DATA || {};
  }

  function buildMachineUrl(brand, equipmentId, model) {
    var data = getData();
    var base = (data.brandCollections && data.brandCollections[brand]) || '/collections/shop-all-parts';
    var parts = [];
    if (brand) parts.push(brand);
    if (model) parts.push(model);
    var equip = (data.equipmentTypes || []).find(function (e) {
      return e.id === equipmentId;
    });
    if (equip && equip.label) parts.push(equip.label);
    if (!parts.length) return base;
    return base + '?q=' + encodeURIComponent(parts.join(' '));
  }

  function populateSelect(select, options, placeholder) {
    if (!select) return;
    var html = '<option value="">' + escapeHtml(placeholder) + '</option>';
    options.forEach(function (opt) {
      html +=
        '<option value="' +
        escapeHtml(opt.value) +
        '">' +
        escapeHtml(opt.label) +
        '</option>';
    });
    select.innerHTML = html;
  }

  function init(root) {
    var data = getData();
    var brandSelect = root.querySelector('[data-pf-brand]');
    var equipSelect = root.querySelector('[data-pf-equipment]');
    var machineForm = root.querySelector('[data-pf-machine-form]');
    var partForm = root.querySelector('[data-pf-part-form]');
    var browseBtn = root.querySelector('[data-pf-browse-cats]');
    var track = root.querySelector('[data-pf-popular-track]');
    var nextBtn = root.querySelector('[data-pf-popular-next]');

    populateSelect(
      brandSelect,
      (data.brands || []).map(function (b) {
        return { value: b, label: b };
      }),
      'Select brand'
    );

    populateSelect(
      equipSelect,
      (data.equipmentTypes || []).map(function (e) {
        return { value: e.id, label: e.label };
      }),
      'Select equipment type'
    );

    if (machineForm) {
      machineForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var brand = brandSelect ? brandSelect.value : '';
        var equipment = equipSelect ? equipSelect.value : '';
        var modelInput = machineForm.querySelector('[data-pf-model]');
        var model = modelInput ? modelInput.value.trim() : '';
        window.location.href = buildMachineUrl(brand, equipment, model);
      });
    }

    if (partForm) {
      partForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = partForm.querySelector('[name="q"]');
        var query = input ? input.value.trim() : '';
        if (!query) return;
        window.location.href =
          '/search?q=' + encodeURIComponent(query) + '&type=product';
      });
    }

    if (browseBtn) {
      browseBtn.addEventListener('click', function () {
        var target = root.querySelector('#tcb-pf-categories');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (nextBtn && track) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' });
      });
    }
  }

  function boot() {
    var root = document.querySelector('[data-tcb-parts-finder-hub]');
    if (!root) return;
    var url = window.TCB_PARTS_FINDER_DATA_URL;
    if (!url) {
      init(root);
      return;
    }
    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        window.TCB_PARTS_FINDER_DATA = data;
        init(root);
      })
      .catch(function () {
        init(root);
      });
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
